import { MediaElement, MediaGrid } from 'editor/src/store/design/types';

function isMediaGrid(elt: MediaElement): elt is MediaGrid {
  return elt.type === 'grid';
}

export default isMediaGrid;
